import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';

export default class UserRoleRewardIsSendedNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return '';
  }

  href() {
    return '#';
  }

  content() {
    const notification = this.attrs.notification;
    let text = app.translator.trans('dl-optimization.forum.userRoleRewardIsSended_text');
    return text;

  }
}
